import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  Output,
  PipeTransform,
  ViewChild,
} from '@angular/core';
import {DropdownToggleService} from '@shared/services/dropdown-toggle.service';
import {CommonModule} from '@angular/common';
import {IFileUpload, NoteAttachments, Notes} from '@core/model/note/note';
import {PageFilterHrLookup} from '@core/model/pagination/filter';
import {PageResult} from '@core/model/pagination/page-result';
import {AuthService} from '@core/services/auth.service';
import {NotifyService} from '@core/services/notify.service';
import {Attachment} from '@generated/queries';
import {ImageResizeService} from '@shared/services/image-resize.service';
import {map, Observable} from 'rxjs';
import {NotesService} from '../note/services/notes.service';
import {TicketStatusChangeService} from '../../../app/layout/pages/tickets/services/ticket-status-change.service';
import {ConvertDateUtcTimezoneService} from '@shared/services/convert-date-utc-timezone.service';
import { FileService } from '@shared/services/file.service';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ApolloError } from '@apollo/client/errors';
import { FileExtension, FileMimeType } from '@shared/model/file-types';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HNotesService } from '../h-notes/h-notes.service';
import { ApiNoteAttachment, MongoNoteDetail } from '../h-notes/h-notes.models';
export class ShortNamePipe implements PipeTransform {
  transform(fullName: string): string {
    return fullName
      .split(' ')
      .map((n) => n[0])
      .join('');
  }

}

@Component({
  selector: 'app-attachment',
  imports: [CommonModule, PdfViewerModule, MatTooltipModule],
  templateUrl: './attachment.component.html',
  standalone: true,
  styleUrl: './attachment.component.css',
})
export class AttachmentComponent implements OnDestroy {
  @ViewChild('chatMessages') chatMessagesRef: ElementRef;
  ticketId= '';
  @Input() objectID = '';
  @Input() noteModuleCode: string;
  @Input() tableDivClass= 'h-450px';
  @Input() notePaddingClass = '';
  @Input() noteCardClass= 'card h-100';
  @Input() emitValues = false;
  @Input() isNoteType: boolean;
  @Input() parentTimeZone: string;
  loading: boolean;
  @Input() assigneeId = null;
  @Input() isStatusDropDown: boolean;
  @Input() isSaveButton = true;
  @Output() isNoteSaved = new EventEmitter<{ noteText: string }>();
  @Output() isChangeAvailable = new EventEmitter<boolean>(false);
  @Output() isChangeAnyThing = new EventEmitter<number>();
  @Input() minHeight: number;
  @Input() isCompleted: boolean;
  @Input() TicketAttachmentsWrite: boolean;
  /** When true, files are queued only; parent calls upload with a real object id (e.g. after create). */
  @Input() deferUpload = false;
  /** Compact row: small add control + removable file chips (e.g. leave dialog). */
  @Input() compactUi = false;
  /** Max files per selection / total queue (default 10). */
  @Input() maxFiles = 10;

  disabled = false;
  /** Object URLs for compact image previews (revoked on remove / clear). */
  private readonly compactPreviewUrls = new Map<string, string>();
  statusId = '';
  isFilter= false;
  lastSavedStatus: string;
  resolutionId= '';
  startDate = '';
  endDate = '';
  search = '';
  createNoteSearch = '';
  isSaveBtnDisabled = false;
  currentUserNameLetter: string;
  isNoteSavedSuccess = false;
  notesLookup: PageResult<Notes> = new PageResult<Notes>();
  notes: Notes[] = [];
  mongoNotes:MongoNoteDetail[]=[];
  mentionRoleUserIdList = [];
  reviewerUserId: string;
  editNote: Notes = new Notes();
  notesText = '';
// eslint-disable-next-line
  notesAttachments: any[] = [];
  lstFiles: File[] = [];
  isUnderReview = false;
  fileToUpload: File | null = null;
  fileUploaded: IFileUpload = new IFileUpload();
  downloadFile: IFileUpload[] = [];
  lstUploadedFiles: IFileUpload[] = [];
  existingUploadedFiles: IFileUpload[] = [];
  positionLat = 0;
  positionLog = 0;
  isuploadDocument: boolean;
  attachments: ['file1.pdf', 'image.jpg'];
  totalFileSize: number;
  editCheck: boolean;
  noteTypeId = '';
  filters: PageFilterHrLookup = {
    pageIndex: 0,
    activeIndex: 1,
    take: 12,
    search: '',
    state: '',
  };
  mentionUserIdList: string[] = [];
  resizedFiles: File[] = [];

  constructor(
    protected dropdownService: DropdownToggleService,
    private authService: AuthService,
    private noteService: NotesService,
    private hNotesService: HNotesService,
    private notifyService: NotifyService,
    private imageResize: ImageResizeService,
    private fService:FileService,
    private statusService: TicketStatusChangeService,
    public utcToTimeZone: ConvertDateUtcTimezoneService
  ) {}

  ngOnDestroy(): void {
    for (const url of this.compactPreviewUrls.values()) {
      URL.revokeObjectURL(url);
    }
    this.compactPreviewUrls.clear();
  }

  reloadData() {
    
    this.hNotesService.getNotes(this.objectID)
      .then(notes => {
        this.mongoNotes = notes;
      });
  }

  // Toggle a specific dropdown
  toggleDropdown(id: string, event: MouseEvent): void {
    event.stopPropagation();
    this.dropdownService.toggleDropdown(id);
  }

  // Check if a dropdown is visible
  isDropdownVisible(id: string): boolean {
    return this.dropdownService.isDropdownVisible(id);
  }

  onLinkClick(event: MouseEvent): void {
    event.stopPropagation();
    this.dropdownService.hideAllDropdowns();
  }

  // Hide all dropdowns when clicking anywhere else in the document
  @HostListener('document:click', ['$event'])
  onDocumentClick(_event: Event): void {
    this.dropdownService.hideAllDropdowns();
  }

  onDivClick(event: MouseEvent): void {
    event.stopPropagation(); // Prevent document click listener from closing dropdown
  }

  async ngOnInit() {
    this.ticketId = this.objectID;
    this.currentUserNameLetter = this.getShortName(this.authService.myName);
    this.disabled =
      this.isCompleted ||
      (!this.deferUpload && !this.TicketAttachmentsWrite);
    if (!this.deferUpload) {
      await this.reloadData();
    }
  }

  filterButtonClicked() {
    this.isFilter = !this.isFilter;
  }

  cancelSearch() {
    this.filterButtonClicked();
    if (this.startDate || this.search) {
      this.startDate = '';
      this.search = '';
    }
    this.endDate = '';
  }


  remove(filename: string): void {
    this.revokeCompactPreview(filename);
    if (this.lstFiles.length > 0) {
      this.lstFiles = this.lstFiles.filter((file) => file.name !== filename);
    }
    this.lstUploadedFiles = this.lstUploadedFiles.filter(
      (e) => e.AttachmentName !== filename
    );
  }

  private revokeCompactPreview(filename: string): void {
    const url = this.compactPreviewUrls.get(filename);
    if (url) {
      URL.revokeObjectURL(url);
      this.compactPreviewUrls.delete(filename);
    }
  }

  /** Files waiting when `deferUpload` is true (e.g. upload after leave is created). */
  getDeferredFiles(): File[] {
    return [...this.lstFiles];
  }

  clearDeferredFiles(): void {
    for (const f of this.lstFiles) {
      this.revokeCompactPreview(f.name);
    }
    this.lstFiles = [];
    this.lstUploadedFiles = [];
    this.resizedFiles = [];
    this.totalFileSize = 0;
  }

  isImageFile(file: File): boolean {
    return file.type.startsWith('image/');
  }

  /** Stable preview URL for compact chips (revoked in remove / clear). */
  previewUrlFor(file: File): string {
    if (!this.isImageFile(file)) {
      return '';
    }
    let url = this.compactPreviewUrls.get(file.name);
    if (!url) {
      url = URL.createObjectURL(file);
      this.compactPreviewUrls.set(file.name, url);
    }
    return url;
  }

  // eslint-disable-next-line
  async handleFileInput(event: any) {
    this.disabled=true
    const files: File[] = Array.from(event.target.files);
    const existingFiles: File[] = Array.from(this.lstFiles ?? []);
    const existingFileNames = new Set(existingFiles.map((file) => file.name));
    
    const supportedTypes = [
  FileMimeType.JPEG,
  FileMimeType.PNG,
  FileMimeType.HEIC,
  FileMimeType.HEIF,
  FileMimeType.PDF,
  FileMimeType.DOC,
  FileMimeType.DOCX,
  FileMimeType.XLS,
  FileMimeType.XLSX,
];

const supportedExtensions: FileExtension[] = [
  FileExtension.JPG,
  FileExtension.JPEG,
  FileExtension.PNG,
  FileExtension.HEIC,
  FileExtension.HEIF,
  FileExtension.PDF,
  FileExtension.DOC,
  FileExtension.DOCX,
  FileExtension.XLS,
  FileExtension.XLSX,
];
    const isSupported = (file: File): boolean => {
  const fileExt = file.name.split('.').pop()?.toLowerCase();
  return (
    supportedTypes.includes(file.type as FileMimeType) ||
    (fileExt && supportedExtensions.includes(`.${fileExt}` as FileExtension))
  );
};

    const skippedDuplicateFiles: string[] = [];
    const skippedUnsupportedFiles: string[] = [];
    const validFiles: File[] = [];

    // Step 1: Validate and skip unsupported or duplicates
    for (const file of files) {
      if (!isSupported(file)) {
        skippedUnsupportedFiles.push(`${file.name}`);
        continue;
      }
      if (existingFileNames.has(file.name)) {
        skippedDuplicateFiles.push(`${file.name}`);
        continue;
      }
      validFiles.push(file);
    }

    // Step 2: Enforce file count limit
    const allowedSlots = Math.max(0, this.maxFiles - existingFiles.length);
    const acceptedFiles = validFiles.slice(0, allowedSlots);
    const droppedDueToLimit = validFiles.length - acceptedFiles.length;
    if (droppedDueToLimit > 0) {
      const title = 'Too many files selected';
      const message = `Only the first ${this.maxFiles} files were selected; the remaining files were not added.`;
      this.errorNotification(message, title);
    }

    // Step 3: Resize image files
    const imageTypes = ['image/jpeg', 'image/png', 'image/heic', 'image/heif'];
    const imageFiles = acceptedFiles.filter((file) => imageTypes.includes(file.type));
    const pdfFiles = acceptedFiles.filter((file) => !imageTypes.includes(file.type));

    const resizePromises = imageFiles.map((file) =>
      this.imageResize.resizeImage(file, 800, 800, 0.7)
    );
    const resizedImages = await Promise.all(resizePromises);
    this.resizedFiles = resizedImages.filter((file) => file !== null);

    // Step 4: Final file list
    this.lstFiles = existingFiles.concat(this.resizedFiles, pdfFiles);
    this.isuploadDocument = false;
    this.lstUploadedFiles = [];
    this.totalFileSize = 0;

    for (const file of this.lstFiles) {
      if (!isSupported(file)) continue;

      const uploadItem = new IFileUpload();
      uploadItem.AttachmentName = file.name;
      uploadItem.AttachmentBlobName = 'notfound';
      this.lstUploadedFiles.push(uploadItem);

      this.totalFileSize += file.size;
      this.isuploadDocument = this.totalFileSize <= 4194304;
    }

    // Step 5: Remove duplicates
    this.lstUploadedFiles = this.lstUploadedFiles.filter(
      (file, index, self) =>
        index === self.findIndex((f) => f.AttachmentName === file.AttachmentName)
    );

    // Step 6: Show skipped file errors
    if (skippedDuplicateFiles.length > 0) {
      this.errorNotification(
        `The following files were already selected and have been skipped: ${skippedDuplicateFiles.join(', ')}`,
        'Duplicate Files Skipped'
      );
    }
    if (skippedUnsupportedFiles.length > 0) {
      this.errorNotification(
        `The following files have unsupported formats and were skipped: ${skippedUnsupportedFiles.join(', ')}`,
        'Unsupported File Type(s)'
      );
    }
    // Step 7: Upload (immediate mode only)
    if (!this.deferUpload && this.lstUploadedFiles.length > 0) {
      await this.OnSubmit(this.objectID);
    }
    this.disabled=false;
    event.target.value = '';
  }

resizeImage(
    file: File,
    maxWidth: number,
    maxHeight: number,
    quality: number
  ): Promise<File> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => {
        const canvas = document.createElement('canvas');
        let width = img.width;
        let height = img.height;

        if (width > height) {
          if (width > maxWidth) {
            height = Math.round(height * (maxWidth / width));
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width = Math.round(width * (maxHeight / height));
            height = maxHeight;
          }
        }

        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);

        canvas.toBlob(
          (blob) => {
            resolve(
              new File([blob], file.name, {
                type: 'image/jpeg',
                lastModified: Date.now(),
              })
            );
          },
          'image/jpeg',
          quality
        );
      };
      img.onerror = (err) => reject(err);
    });
  }


  truncateFileName(filePath: string): string {
    const urlParts = filePath.split('/');
    const fullFileName = urlParts[urlParts.length - 1]; // Get last part of the path
    const maxLength = 15;
    const fileType = fullFileName.split('.').pop(); // file extension
    const fileNameWithoutExt = fullFileName.substring(0, fullFileName.lastIndexOf('.'));

    return fullFileName.length > maxLength
      ? fileNameWithoutExt.slice(0, maxLength - 2) + '....' + fileType
      : fullFileName;
  }


  resetNote() {
    this.startDate = '';
    this.endDate = '';
    this.search = '';
    this.editCheck = false;
    this.isSaveBtnDisabled = false;
    this.lstUploadedFiles = [];
    this.existingUploadedFiles = [];
    this.lstFiles = [];
  }

  edit(item: Notes) {
    this.isSaveBtnDisabled = false;
    this.editCheck = true;
    this.editNote = item;
    this.lstUploadedFiles = [];
    this.existingUploadedFiles = [];
    item.attachments.forEach((x) => {
      const uploadItem = new IFileUpload();
      uploadItem.AttachmentName = this.getFileName(x.path) as string;
      uploadItem.AttachmentBlobName = x.path as string;
      this.lstUploadedFiles.push(uploadItem);
      this.existingUploadedFiles.push(uploadItem);
    });
  }

  notesLookup$: Observable<PageResult<Notes>>;
  findNoteById(id: string): Observable<Notes | undefined> {
    return this.notesLookup$.pipe(
      map((pageResult) => {
        // Check if data exists and is an array
        if (pageResult.data && Array.isArray(pageResult.data)) {
          // Find the note with the given ID
          return pageResult.data.find((note) => note.id === id);
        } else {
          return undefined;
        }
      })
    );
  }
  getAttachmentLength() {
    return this.lstFiles.length;
  }

  // async fillNote(objectId: string) {
  //   const noteData = await this.noteService.getNotesByObjectId(
  //     objectId,
  //     null
  //   );
  //   if (noteData?.data.length > 0)
  //     this.edit(noteData.data[noteData?.data?.length - 1]);
  // }

  
  private mongoNoteToNotes(api: MongoNoteDetail): Notes {
        const note = new Notes();
        note.id = api.noteId;
        note.objectID = api.objectId;
        note.businessId = api.businessId;
        note.noteText = api.noteText;
        note.noteTypeId = api.noteTypeId ?? undefined;
        note.noteModuleCode = api.noteModuleCode;
        note.updatedOn = api.updatedOn;
        note.userName = api.userName ?? api.createdByUserName ?? undefined;
        note.userPic = api.userPic ?? api.createdByUserPic ?? undefined;
        note.attachments = (api.attachments ?? []).map((a) => ({
          path: a.attachmentUrl,
        }));
        return note;
  }

  async fillNote(objectId: string): Promise<void> {
      if (!objectId) {
        return;
      }
      const notes = await this.hNotesService.getNotes(objectId);
      if (!notes?.length) {
        return;
      }
      const latest = [...notes].sort(
        (a, b) =>
          new Date(b.updatedOn).getTime() - new Date(a.updatedOn).getTime()
      )[0];
      this.edit(this.mongoNoteToNotes(latest));
    }

  // Helper function to get local date in 24-hour format
  getLocalDate24Hour(newDate?: Date): string {

    const localDate = newDate ?? new Date();

    const formattedDate =
      `${(localDate.getMonth() + 1).toString().padStart(2,'0')}/` +
      `${localDate.getDate().toString().padStart(2,'0')}/` +
      `${localDate.getFullYear()} ` +
      `${localDate.getHours().toString().padStart(2,'0')}:` +
      `${localDate.getMinutes().toString().padStart(2,'0')}:` +
      `${localDate.getSeconds().toString().padStart(2,'0')}`;

    return formattedDate;
  }


  // eslint-disable-next-line
  async OnSubmit(id?:string) {
    // Always create a new note with the uploaded files (addNote) every time
    this.isChangeAnyThing.emit(1);
    const currentDate = new Date();
    const newComment = new Notes();
    newComment.objectID = this.objectID;
    newComment.noteModuleCode = this.noteModuleCode;
    newComment.updatedOn = this.getLocalDate24Hour(this.utcToTimeZone.convertLocalTimeToUTC(currentDate, this.parentTimeZone));

    const newCommentMessage: Notes = {
      id: '0',
      objectID: newComment.objectID,
      TicketId: this.ticketId,
      noteModuleCode: newComment.noteModuleCode,
      noteText: 'N/A',
      updatedOn: this.getLocalDate24Hour(this.utcToTimeZone.convertLocalTimeToUTC(currentDate, this.parentTimeZone)),
      attachment: false,
      businessId: this.authService.businessId,
      updatedById: this.authService.id,
      noteTypeId: null,
      mentionUserIdList: this.mentionUserIdList
    };

    await this.noteService
      .addNote(newCommentMessage, this.lstFiles, this.mentionUserIdList)
      .then(async () => {
        this.loading = false;
        this.isSaveBtnDisabled = false;
        this.lstUploadedFiles = [];
        this.resizedFiles = [];
        this.lstFiles = [];
        await this.reloadData();
      })
      .catch((err) => {
        this.isSaveBtnDisabled = false;
        this.showErrorMessage(err);
        this.loading = false;
      });
    this.disabled = false;
  }

  showSuccessMessage() {
    this.notifyService.success({
      message: 'Attachment Created Successfully',
    });
  }

  showErrorMessage(error: ApolloError) {
    const graphQLError = error.graphQLErrors[0];

    this.notifyService.error({
      message: graphQLError.message,
      type: graphQLError.extensions?.['type'] as string, // ✅ safe cast + correct access
    });
  }


  errorNotification(eMessage: string, eType: string) {
    this.notifyService.error({
      message: eMessage,
      type: eType,
    });
  }

  // eslint-disable-next-line
  downloadNoteFile(event: any) {
    this.noteService.downloadMyFile(event);
  }

  getShortName(name: string) {
    const nameArr = name.split(' ');
    return Array.from(nameArr[0])[0];
  }

  getFileName(fullpath: string): string {
    return fullpath.split('/').pop()!;
  }

  getFileExtension(path: string): string {
    return path.substring(path.lastIndexOf('.') + 1).toLowerCase();
  }

  getFileIcon(path: string): string {
    const ext = this.getFileExtension(path);
    switch (ext) {
      case 'pdf': return './assets/images/icons/files/pdf.svg';
      case 'doc':
      case 'docx': return './assets/images/icons/files/doc.svg';
      case 'xls':
      case 'xlsx': return './assets/images/icons/files/excel.svg';
      case 'jpg':
      case 'jpeg': return './assets/images/icons/files/jpeg.svg';
      case 'png': return './assets/images/icons/files/png.svg';
      case 'heic': return './assets/images/icons/files/heic.svg';

      default: return './assets/images/icons/files/file.svg';
    }
  }


  colorsClass: string[] = ['bg-danger', 'bg-warning', 'bg-success', 'bg-dark'];
  currentColorPickedIndex = 0;
  getAlternateColorClass() {
    if (this.currentColorPickedIndex + 1 > this.colorsClass.length - 1) {
      this.currentColorPickedIndex = 0;
    } else {
      this.currentColorPickedIndex = this.currentColorPickedIndex + 1;
    }
    return this.colorsClass[this.currentColorPickedIndex];
  }


  //Show the imageViewer

  async showImageViewer(images: string[], index: number) {
    this.loading = true;
    const filePath = images[index];
    const fileExt = this.getFileExtension(filePath);

    // For pdf/doc/docx/heic → download
    if (["pdf", "doc", "docx", "heic"].includes(fileExt)) {
      this.downloadNoteFile(filePath);
      this.loading = false;
      return;
    }

    // Otherwise → filter images
    const filteredImages = images.filter(img => {
      const ext = this.getFileExtension(img);
      return !["pdf", "doc", "docx", "heic"].includes(ext);
    });

    // Find new index in filteredImages
    const filteredIndex = filteredImages.indexOf(filePath);

    this.loading = false;
    this.fService.viewImage(filteredImages, filteredIndex);
  }




  getAttachmentPaths(attachments: ApiNoteAttachment[]): string[] {
    return attachments.map(x => x.attachmentUrl);
  }

}
